module.exports = __webpack_public_path__ + "VIPC3.png?b82e55f2d4a43a489d7515d7f56f2847";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/cycling/VIPC3.png
// module id = 66
// module chunks = 0